/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, Paper } from '@mui/material';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CustomIcon from './CustomIcon';
import Label from '../type/Label';
import { useLocation } from 'react-router';
import { analyticsTrackEvent, getMappedClickEventPathName } from '../../../utils/analytics/analytics-utils';
import { useDispatch, useSelector } from 'react-redux';
import { cleanUpSideItem, setSideNavItem } from '../../../redux/sidenavItems/actions';
import { updateDemographicsCleanUp } from '../../../redux/demographics/actions';


const SideNavbar = props => {
  const location = useLocation();
  const getId = str => {
    return str.split('-')[1];
  };
  const dispatch = useDispatch();
  const [_, setSelectedIndex] = React.useState(
    location.hash ? Number(getId(location.hash)) : 0
  );
  useEffect(() => {
    dispatch(cleanUpSideItem());
    dispatch(updateDemographicsCleanUp());
  }, []);
  const sideNavItem = useSelector(state => state?.sideNavItem?.activeNavItem);


  const handleListItemClick = (event, index, item) => {
    setSelectedIndex(index);
    analyticsTrackEvent(`${getMappedClickEventPathName(item?.content)}_clicked`, { eventCategory: 'Plan Benefits Pathing' });
    dispatch(setSideNavItem(item.link));
    dispatch(updateDemographicsCleanUp());

  };

  const [selectedOption, setSelectedOption] = React.useState(0);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <>
      <div className='show-mobile-menu'>
        <FormControl fullWidth>
        <InputLabel shrink={true}  className='selectTitle'>
          <Label id="selectABenifit"/>
        </InputLabel>
          <Select
            value={selectedOption}
            onChange={(event) => handleChange(event)}
            inputProps={{ 'aria-label': 'Without label' }}
          >
           
            {props.navItems.map((item, index) => (
              <MenuItem key={index} value={index}
              component="a"
              id="benefits-nav-list-item"
              onClick={event => handleListItemClick(event, index, item)}
              href={`#box-${index}`}
              >
                {item.title}
              </MenuItem>
            ))}

          </Select>
        </FormControl>

        {/* <select>
          {props.navItems.map((item, index) => (
            <option key={index}
              selected={selectedIndex === index}
              onClick={event => handleListItemClick(event, index, item)} id={item.id}>
              {item.title}
            </option>
          ))}
        </select> */}
      </div>
      <Box className={props.sideNavItemClassName}>
        <Paper elevation={8}>

          <List className='show-desktop-menu'>
            {props.navItems.map((item, index) => (
              <ListItem
                button
                key={index}
                component="a"
                selected={item.link === sideNavItem}
                onClick={event => handleListItemClick(event, index, item)}
                className={item.buttonClassName}
                href={`#box-${index}`}
                id={item.id}
              >
                {item.Icon && (
                  <ListItemIcon>
                    <CustomIcon
                      iconName={item.Icon}
                      className={item.iconClassName}
                    />
                  </ListItemIcon>
                )}
                <ListItemText className='settingsLinkText' primary={<Label id={item.id} />} />
                {item.endIcon && (
                  <CustomIcon
                    iconName={item.endIcon}
                    className={item.iconClassName}
                  />
                )}
              </ListItem>
            ))}
          </List>
        </Paper>
      </Box>
    </>
  );
};

SideNavbar.propTypes = {
  navigate: PropTypes.func,
  navItems: PropTypes.array,
  Icon: PropTypes.string,
  endIcon: PropTypes.string,
  className: PropTypes.string,
  sideNavItemClassName: PropTypes.string
};
/* eslint enable */
export default SideNavbar;
